











































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { CourseProductView } from '@/model/product/courseProduct'
import { saveMyLearn } from '@/api/course/course'
import { State, Action, namespace } from 'vuex-class'
import { Child } from '@/model/course/course'
import ShoppingCart from '@/model/product/shoppingCart'
import { saveMystudyPlanTopic } from '@/api/product/shoppingCart'
import { Authority } from '@/apps/ice/model/authority'
import str2base64 from '@/apps/ice/utils/path'

const ModuleUser = namespace('app-ice/user')
const ModuleProduct = namespace('app-ice/product')

@Component
export default class CourseItem extends Vue {
  @ModuleUser.Getter('currentCourse')
  currentCourse?: Child

  @Prop({ type: Boolean, default: false })
  private actived!: boolean
  @Prop()
  private course!: CourseProductView | Child
  @Prop()
  private authority!: Authority
  @Prop()
  private bought!: boolean
  @Prop()
  private current?: boolean
  @Prop({ type: Boolean, default: false })
  private lineLight!: boolean
  @Prop()
  private expiry!: boolean
  @Prop({ type: Boolean, default: true })
  private needTimeLine!: boolean
  @Prop()
  private collegeType?: string
  @Prop()
  private expiryDate?: string

  get localCurrent() {
    if (!this.current && this.course && this.course.courseId) {
      return (
        !!this.currentCourse && this.currentCourse.id === this.course.courseId
      )
    }
    return this.current || false
  }

  Authority: any = Authority
  private productTag: any = {
    NEW: 'NEW',
    PRESALE: '预售',
    VIDEO: '视频',
    FREE: '免费',
    HOT: 'HOT',
  }

  @ModuleUser.Action('getMyLearn')
  getMyLearn!: Function
  @ModuleUser.Action('handleMyLearn')
  handleMyLearn!: Function

  // @ModuleProduct.Action('joinCollege')
  // joinCollege!: Function
  // @ModuleProduct.Action('closeProductModal')
  // closeProductModal!: Function

  // private async save2ShoppingCart() {
  //   const product: ShoppingCart = {
  //     products: [this.course]
  //   }
  //   const res: ShoppingCart = await saveMystudyPlanTopic(product)
  //   if (res) {
  //     this.$ykdmessage({
  //       message: '课程已成功添加到购物车！',
  //       duration: 1000,
  //       cancel: () => {},
  //       type: 'success'
  //     })
  //     setTimeout(() => {
  //       this.joinCollege([this.course])
  //     }, 1100)
  //   }
  // }

  resizeImg(src: string, size: number) {
    if (!src || src.indexOf('image/resize') !== -1) {
      return src
    }
    return `${src}?x-oss-process=image/resize,m_lfit,w_${size}`
  }

  get localExpiry() {
    return this.expiry
  }

  get fraction() {
    if (this.percent && this.outlinesLength) {
      const learned = Math.round((this.percent * this.outlinesLength) / 100)
      return `${learned}/${this.outlinesLength}`
    }
    return ''
  }

  get percent() {
    if (this.course && this.course.myCourse && this.course.myCourse.process) {
      return this.course.myCourse.process > 100
        ? 100
        : this.course.myCourse.process < 0
        ? 0
        : this.course.myCourse.process
    }
    return 0
  }

  get outlinesLength() {
    if (this.course && this.course.outlines) {
      return this.course.outlines.length
    }
    return 0
  }

  get lastLearnTime() {
    if (this.course) {
      return (this.course.myCourse && this.course.myCourse.gmtModified) || ''
    }
    return ''
  }

  private async saveMyLearn() {
    if (
      !this.course ||
      this.localExpiry ||
      this.course.productTag === 'PRESALE'
    ) {
      return
    }

    let courseId
    // 阶段课程学生，从学院面板点去学习
    // 其他任何情况
    if (this.authority === Authority.COLLEGE && this.course.courseId) {
      courseId = this.course.courseId
      await saveMyLearn([courseId], this.expiryDate)
    } else if (this.course.courseId) {
      courseId = this.course.courseId
      await saveMyLearn([courseId], this.expiryDate)
    } else {
      courseId = this.course.id!
      await saveMyLearn([courseId])
    }

    let learnUrl = ''
    if (this.course && this.course.myCourse && this.course.unlock) {
      learnUrl = `https://ham.youkeda.com/course/${courseId}/${str2base64(
        this.course.myCourse.learnUrl || ''
      )}`
    }

    learnUrl =
      learnUrl ||
      `https://ham.youkeda.com/course/${courseId}/${str2base64('0/0/0')}`
    window.open(learnUrl)
    await this.getMyLearn()
    this.handleMyLearn()
  }

  private getLastLearnTime() {
    const dt = new Date(Date.parse(<string>this.lastLearnTime))
    const year = dt.getFullYear()
    const months = this.padStart(dt.getMonth() + 1)
    const day = this.padStart(dt.getDate())
    const h = this.padStart(dt.getHours())
    const m = this.padStart(dt.getMinutes())
    return `${year}-${months}-${day} ${h}:${m}`
  }

  private padStart(num: number) {
    return `${num}`.padStart(2, '0')
  }

  private toDetail() {
    if (!this.course) {
      return
    }

    if (this.authority === Authority.JOB && !this.actived) {
      return
    }

    // 已购买，去学习
    this.bought && this.saveMyLearn()

    // todo 区分学院
    const search = this.collegeType
      ? `?college=${this.collegeType.toLowerCase()}`
      : ''
    !this.bought &&
      window.open(`https://www.youkeda.com/home_m/college${search}`)

    // !this.bought && this.save2ShoppingCart()
  }
}
